/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For more information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.role.list",
    title: "Email Role List",
    description: "Displays a heading followed by a list of roles (title — description) in platform emails.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {
        "heading": {
            title: "Heading",
            type: "string",
            description: "Section heading above the role list.",
            required: false,
            default: "Your access includes:"
        },
        "roles": {
            title: "Roles",
            type: "array",
            description: "Array of role objects or role-name strings.",
            required: false,
            default: []
        }
    }
});
var $ = require("../../../uam/scafolding.js");

exports.render = async function (options) {
    var { html } = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.role.list",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    var heading = (options && options.heading) ? options.heading : "Your access includes:";
    var roles   = (options && Array.isArray(options.roles)) ? options.roles : [];
    var cfg = $.config || {};
    var primary = (cfg.my && cfg.my.app && cfg.my.app.colors && cfg.my.app.colors.primary) || "#6C757D";
    var text = (cfg.my && cfg.my.app && cfg.my.app.colors && cfg.my.app.colors.text) || "#000000";

    var roleRows = "";
    var textLines = [];

    var i = 0;
    while (i < roles.length) {
        var role = roles[i];
        var title = "";
        var desc  = "";

        if (typeof role === "string") {
            title = role;
        } else if (role && typeof role === "object") {
            title = role.title || role.namespace || "";
            desc  = role.description || "";
        }

        roleRows += `<tr>
  <td style="padding:6px 0;font-family:Arial,Helvetica,sans-serif;font-size:15px;color:${text};">
    <strong>${title}</strong>${desc ? " — " + desc : ""}
  </td>
</tr>`;
        textLines.push(title + (desc ? " — " + desc : ""));
        i++;
    }

    if (roles.length === 0) {
        roleRows = `<tr><td style="padding:6px 0;font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#ADB5BD;">No roles assigned.</td></tr>`;
        textLines.push("No roles assigned.");
    }

    var html = `<tr>
  <td style="padding:20px 20px 10px 20px;">
    <p style="margin:0 0 10px 0;padding:0;font-family:Arial,Helvetica,sans-serif;font-size:15px;font-weight:bold;color:${primary};">${heading}</p>
    <table width="100%" border="0" cellpadding="0" cellspacing="0">
      ${roleRows}
    </table>
  </td>
</tr>`;

    var text = heading + "\n" + textLines.join("\n");

    return { html, text };
};
